import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'react-responsive-modal'
import { connect } from 'react-redux'
import { getPackageCategories, getPackageCategoriesLoading } from '../../selectors'
import { getSimilarWords } from 'SRC/modules/categories/selectors'
import { AdditionalPreloader } from 'src/ui/Preloader'
import config from 'SRC/config/config.yaml'

export class PackageCategories extends React.Component {
  state = {
    filteredCategories: null
  }

  onTextSearch = (event) => {
    const { similarWords, packageCategories } = this.props

    const value = event.target.value

    const replaceLetters = [['š', 's'], ['đ', 'dj'], ['č', 'c'], ['ć', 'c'], ['ž', 'z']]

    let searchText = value.toLowerCase()

    replaceLetters.forEach(letter => {
      searchText = searchText.replaceAll(letter[0], letter[1])
    })

    const foundCategoriesBySimilarWords = Array.isArray(similarWords)
      ? similarWords.filter(wordCategoryPair => {
        let word = wordCategoryPair[0]

        replaceLetters.forEach(letter => {
          word = word.replaceAll(letter[0], letter[1])
        })

        return word.toLowerCase().indexOf(searchText) > -1
      }).map(wordCategoryPair => wordCategoryPair[1])
      : []

    const foundCategoriesByTitle = packageCategories.filter(packageCategory => {
      const category = packageCategory.category

      let categoryTitle = category.title.toLowerCase()

      replaceLetters.forEach(letter => {
        categoryTitle = categoryTitle.replaceAll(letter[0], letter[1])
      })

      return categoryTitle.indexOf(searchText) > -1
    }).map(packageCategory => packageCategory.category.id)

    const foundCategories = foundCategoriesBySimilarWords.concat(foundCategoriesByTitle)

    const filteredCategories = value === '' ? null : Array.from(new Set(foundCategories))

    this.setState({
      filteredCategories
    })
  }

  renderPackageCategories () {
    const { packageCategories, isPackageCategoriesLoading } = this.props
    const { filteredCategories } = this.state

    console.log('fc', filteredCategories)

    let categories = packageCategories

    if (Array.isArray(filteredCategories)) {
      categories = packageCategories.filter(packageCategory => {
        return packageCategory.category && filteredCategories.includes(packageCategory.category.id)
      })
    }

    return !isPackageCategoriesLoading ? <table className='tabela-izabrano' style={{width: '100%'}}>
      <tbody>
        <tr>
          <th>{config.registrationForm.package.packageCategoriesModal.column1}</th>
          <th>{config.registrationForm.package.packageCategoriesModal.column2}</th>
        </tr>
        {categories.map(packageCategory => (
          <tr key={`package-category-${packageCategory.id}`}>
            <td>{packageCategory.category.title}</td>
            <td>{packageCategory.adLimit}</td>
          </tr>
        ))}
      </tbody>
    </table> : <AdditionalPreloader />
  }

  render () {
    const { page, show, onClose } = this.props
    if (!page) return null

    if (page === 'registration') {
      return <Modal open={show} onClose={onClose}
        styles={{ modal: { width: '100%', height: '60%', overflow: 'auto' } }} center>
        <h1>{config.registrationForm.package.packageCategoriesModal.header}</h1>
        <div className='registracija-table'>
          <input
            className='package-categories-search'
            type='text'
            placeholder='Upiši naziv kategorije...'
            onChange={this.onTextSearch}
          />

          {this.renderPackageCategories()}
        </div>
      </Modal>
    }

    if (page === 'profile') {
      return <React.Fragment>
        <input
          className='package-categories-search'
          type='text'
          placeholder='Upiši naziv kategorije...'
          onChange={this.onTextSearch}
        />

        {this.renderPackageCategories()}
      </React.Fragment>
    }
    return null
  }
}

const mapStateToProps = state => ({
  packageCategories: getPackageCategories(state),
  isPackageCategoriesLoading: getPackageCategoriesLoading(state),
  similarWords: getSimilarWords(state)
})

PackageCategories.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  packageCategories: PropTypes.array.isRequired,
  similarWords: PropTypes.arrayOf(PropTypes.array).isRequired,
  isPackageCategoriesLoading: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(PackageCategories)
